export const LIST = 'LIST'
export const LIST_LATEST = 'LIST_LATEST'
export const SELECT = 'SELECT'
export const CLEAR_ALL = 'CLEAR_ALL'
export const CLEAR_SELECTED = 'CLEAR_SELECTED'
export const CLEAR_LATEST = 'CLEAR_LATEST'
